import React, { useState, useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios';

const ContactUs = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [companyname, setCompanyname] = useState("");
    const [number, setNumber] = useState("");
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState({
        type: "",
        message: ""
    });
    const [loading, setLoading] = useState(false);
    const [errormessage, setErrormessage] = useState("");

    const [error, setError] = useState("");
    const captchaRef = useRef(null);
    useEffect(() => {
        // console.log("ReCAPTCHA site key:", process.env.REACT_APP_RECAPTCHA_SITE_KEY);
    }, []);
    
    const handleSubmit = async e => {
        e.preventDefault();
        setStatus({ type: "", message: "" });
        setLoading(true);

        // Validate all fields are filled
        if (!(name && email && companyname && number && message)) {
            setStatus({
                type: "error",
                message: "All fields are required"
            });
            setLoading(false);
            return;
        }

        const token = captchaRef.current?.getValue() || "";
        
        if (!token) {
            setStatus({
                type: "error",
                message: "Please verify that you are not a robot"
            });
            setLoading(false);
            return;
        }

        try {
            const apiUrl = process.env.REACT_APP_API_BASE_URL;
            const response = await axios.post(`${apiUrl}/security/contact-us`, {
                name,
                email,
                companyname,
                number,
                message,
                // token
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            // console.log('Server response:', response.data);
            // console.log('Server response status :', response.data.success);

            if (response.data.success) {
                setName("");
                setEmail("");
                setCompanyname("");
                setNumber("");
                setMessage("");
                // captchaRef.current.reset();
                
                setStatus({
                    type: "success",
                    message: response.data.message || "Thank you! Your message has been sent successfully."
                });
            } else {
                setStatus({
                    type: "error",
                    message: response.data.message || "Something went wrong. Please try again."
                });
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            
            if (error.response) {
                console.error("Server error data:", error.response.data);
                console.error("Server error status:", error.response.status);
                
                setStatus({
                    type: "error",
                    message: error.response.data?.message || `Server error (${error.response.status}): Please try again later.`
                });
            } else if (error.request) {
                console.error("No response received:", error.request);
                setStatus({
                    type: "error",
                    message: "No response from server. Please check your internet connection and try again."
                });
            } else {
                setStatus({
                    type: "error",
                    message: "Failed to send request: " + error.message
                });
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <section id="CONTACT-US" className="contact">
            <div className="container">
                <div className="section-title" data-aos="zoom-out">
                    <p style={{ fontWeight: 'bold', color: 'rgba(4,52,111)' }} className='text-center'>Contact Us</p>
                </div>
                <div className="row mt-5">
                    <div className="col-lg-4" data-aos="fade-up">
                        <div className="info">
                            <div className="address">
                                <a
                                    // href="https://www.google.com/maps?q=1007,+10th+Floor,+Manjeera+Trinity+Corporate,+Kukatpally+Housing+Board+Colony,+Kukatpally,+Hyderabad+500072,+Telangana,+India"
                                    href="https://www.google.com/maps/place/Lab+Iconics+Technologies+LLP/@17.4558956,78.3713011,19z/data=!4m9!1m2!2m1!1s3rd+Floor,+TRENDZ+PLATINA+!3m5!1s0x3bcb8dd09657e54b:0x1d182f97660446a7!8m2!3d17.4560003!4d78.3713304!16s%2Fg%2F11kgg7t709?entry=ttu&g_ep=EgoyMDI1MDIxMi4wIKXMDSoASAFQAw%3D%3D"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: 'inherit', textDecoration: 'none' }}
                                    > <i className="bi bi-geo-alt"></i></a>
                                <h4 className='text-start' style={{ color: 'rgba(4,52,111)' }}>Location:</h4>
                                <p className='text-start'><a
                                    
                                    // href="https://www.google.com/maps?q=1007,+10th+Floor,+Manjeera+Trinity+Corporate,+Kukatpally+Housing+Board+Colony,+Kukatpally,+Hyderabad+500072,+Telangana,+India"
                                    href="https://www.google.com/maps/place/Lab+Iconics+Technologies+LLP/@17.4558956,78.3713011,19z/data=!4m9!1m2!2m1!1s3rd+Floor,+TRENDZ+PLATINA+!3m5!1s0x3bcb8dd09657e54b:0x1d182f97660446a7!8m2!3d17.4560003!4d78.3713304!16s%2Fg%2F11kgg7t709?entry=ttu&g_ep=EgoyMDI1MDIxMi4wIKXMDSoASAFQAw%3D%3D"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: 'black', textDecoration: 'none', fontSize: '15px', fontStyle: 'Arial' }}
                                >3rd Floor, TRENDZ PLATINA, 2-91/12/TP,
                                Survey No.12(P), Kondapur Village, 
                                Serilingampally Mandal, Ranga Reddy District,
                                Hyderabad – 500081. Telangana.
                                India.</a></p>
                            </div>
                            <div className="email">
                                <a href="mailto:info@labiconics.com" > <i className="bi bi-envelope"></i></a>
                                <h4 className='text-start' style={{ color: 'rgba(4,52,111)' }}>Email:</h4>
                                <p className='text-start' ><a href="mailto:info@labiconics.com" className='text-dark' style={{ fontSize: '15px', textDecoration: 'none' }}>info@labiconics.com</a></p>
                            </div>
                            <div className="phone">
                                <a href="tel:+918008003103" style={{ color: 'inherit', textDecoration: 'none' }}><i className="bi bi-phone"></i></a>
                                <h4 className='text-start' style={{ color: 'rgba(4,52,111)' }}>Call:</h4>
                                <p className='text-start'>
                                    <a href="tel:+918008003103" style={{ color: 'black', textDecoration: 'none', fontSize: '15px' }}>+91 8008003103</a> /
                                    <a href="tel:+918008009926" style={{ color: 'black', textDecoration: 'none', fontSize: '15px' }}>+91 8008009926</a>
                                </p>
                                <p> </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-8 mt-5 mt-lg-0" data-aos="fade-up">

                        <form onSubmit={handleSubmit} encType='text/plain' className="php-email-form">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        onChange={(e)=>setName(e.target.value)}
                                        placeholder="Your Name"
                                        required
                                        value={name}
                                    />
                                </div>
                                <div className="col-md-6 form-group mt-3 mt-md-0">
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        onChange={e => setEmail(e.target.value.toLocaleLowerCase())}
                                        placeholder="Your Email"
                                        required
                                        value={email}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <input
                                        type="text"
                                        name="companyname"
                                        className="form-control"
                                        onChange={e => setCompanyname(e.target.value)}
                                        placeholder="Company Name"
                                        required
                                        value={companyname}
                                    />
                                </div>
                                <div className="col-md-6 form-group mt-3 mt-md-0">
                                    <input
                                        type="tel"
                                        name="number"
                                        className="form-control"
                                        onChange={e => setNumber(e.target.value)}
                                        placeholder="Phone Number"
                                        maxLength="12"
                                        required
                                        value={number}
                                    />
                                </div>
                            </div>
                            <div className="form-group mt-3">
                                <textarea
                                    name="message"
                                    className="form-control"
                                    onChange={e => setMessage(e.target.value)}
                                    rows="5"
                                    placeholder="Message"
                                    required
                                    value={message}
                                ></textarea><br></br>
                            </div>

                            {/* <div className="text-center d-flex flex-row justify-content-center">
                                <ReCAPTCHA sitekey='6LfQPPwpAAAAAMG3JAezzQkxr7Zgxodyg7GGgwGj' ref={captchaRef} />
                            </div>
                            <br></br>
                            <div className="text-center">
                                <button type="submit" style={{ background: '#47b2e4', borderRadius: '0px' }}>Send Message</button>
                            </div>
                            <div className='text-center'>
                                {
                                    error && <p className='textError text-center' style={{ color: 'red' }}>Error!! {error}</p>
                                }
                                {
                                    errormessage && <p className='textSuccess text-center' style={{ color: 'red' }}>Success!! {errormessage}</p>
                                }
                            </div> */}

                            <div className="text-center d-flex flex-row justify-content-center">
                                <ReCAPTCHA 
                                    sitekey='6LfQPPwpAAAAAMG3JAezzQkxr7Zgxodyg7GGgwGj'
                                    ref={captchaRef} 
                                />
                            </div>
                            <br></br>
                            <div className="text-center">
                                <button 
                                    type="submit" 
                                    disabled={loading}
                                    style={{ background: '#47b2e4', borderRadius: '0px' }}
                                >
                                    {loading ? 'Sending...' : 'Send Message'}
                                </button>
                            </div>
                            <div className='text-center mt-3'>
                                {status.message && (
                                    <p 
                                        className={`text-center ${status.type === 'error' ? 'text-danger' : 'text-success'}`}
                                    >
                                        {status.message}
                                    </p>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </section>
    );
};

export default ContactUs;
